// ----------------------------------------------------------------------
// <copyright file="Izenda.Destination.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Destination component
 */
!(function() {


  var m = require('mobx');
  var React = require('react');
  var EventUtils = require('EventUtils');
  var connect = require('share/enhancers/Izenda.Connect');

  var constants = require('logic/data/Izenda.CopyManagementConstants');
  var commonMessages = require('share/messages/Izenda.CommonMessages');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var Select = Validator()(require('share/components/controls/multiSelectBox/Izenda.Select'));
  var observer = require('mobx-react').observer;
  const { isNil } = require('lodash/fp');

  var Destination = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      title: React.PropTypes.string.isRequired
    },

    render: function() {
      var props = this.props;
      var store = props.store;
      var options = store.item.destinationDropdownOpts;

      return (
        <div className="u_table u_fullWidth">
          <div className="u_tableCell u_alignMiddle">{this.props.title}</div>
          <div className="u_tableCell u_fullWidth u_alignMiddle">
            <Select
              multi={true}
              simpleValue
              className="col-md-12"
              options={options}
              labelKey="name"
              valueKey="id"
              noResultsText="No result"
              onChange={this.updateSelectedTenant}
              allowCreate={false}
              value={store.item.selectedDestinationTenantIDs}
              validations={constants.DESTINATION_CONSTRAINTS}
              blankOption={true}
              disabled={isNil(store.item.sourceId)}
            />
          </div>
        </div>
      );
    },

    updateSelectedTenant: function(tenantId) {
      var store = this.props.store;
      store.item.setAlertMessage(commonMessages.EMPTY_MESSAGE);
      store.item.updateSelectedTenantsForDestination(tenantId).then(store.loadDistinctConnections.bind(store));
    }
  });

  module.exports = observer(connect()(Destination));
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/AdditionalItems/Izenda.Destination.jsx